import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A1612] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="text-sm font-light text-[#F6F4F1] tracking-wide">
              {t('footer.copyright')}
            </p>
            <p className="text-sm font-light text-[#F6F4F1]/70 tracking-wide">
              {t('footer.tagline')}
            </p>
          </div>
          <a 
            href={t('contact.instagramUrl')}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-light text-[#F6F4F1] hover:opacity-70 transition-opacity duration-300"
          >
            {t('contact.instagram')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
